module.exports = __webpack_public_path__ + "static/media/upload-your-digital-content.47738413.png";